import Footer from '@/components/common/Footer';
import Sidebar from '@/components/common/Sidebar';
import BottomNav from '@/components/BottomNav';
import Header from '@/components/Header';
import { StickySportStrip } from '@/components/common/SportStrip';
import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

// Pages already redesigned for V2; they follow the user's dark/light theme.
const V2_PAGES = [
  '/home',
  '/all-sports/',
  '/user/account-statement',
  '/user/bet-history',
  '/user/activity-logs',
  '/user/casino-bet-history',
  '/user/bonus-statement',
  '/user/transactions',
  '/user/change-password',
  '/profile',
  '/rules',
  '/deposit',
  '/withdraw',
  '/referral',
  '/offers',
];

const MainLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { pathname } = useLocation();
  const isV2Page = V2_PAGES.some((path) => pathname.startsWith(path));

  return (
    <div className="bg-shell">
      <Header onMenuClick={() => setIsSidebarOpen(true)} />

      <div className="flex min-h-[calc(100vh-169px)]">
        <Sidebar isOpen={isSidebarOpen} onToggle={() => setIsSidebarOpen(false)} />

        {/* Pages not redesigned yet keep their light look; forcing the light theme here also
            keeps shared V2 components (tables, inputs) light on them. */}
        {/* `overflow-clip`, not `overflow-hidden`, so the sport strip can stick while scrolling. */}
        <div className="min-w-0 flex-1 overflow-clip">
          <StickySportStrip />
          <main
            data-theme={isV2Page ? undefined : 'light'}
            className={`min-w-0 overflow-hidden ${isV2Page ? '' : 'bg-surface'}`}
          >
            <Outlet />
          </main>
        </div>
      </div>
      {/* Footer */}
      <Footer />
      <BottomNav />
    </div>
  );
};

export default MainLayout;
